import React, { Component, Fragment } from 'react'
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import DialogContentText from '@material-ui/core/DialogContentText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';


const styles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 250,
  }
});

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0a58ca',
    },
  },
});

class ModalSelectRoom extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      habitaciones: [],
      habitacion: props.room,
    };
  }

  handleClose = () => {
    this.setState({ open: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  handleHabitacion = () => {
    this.props.onSave(this.state.habitacion);
  };

  handleChange = (event) => {
    this.setState({ habitacion: event.target.value });
  };

  loadRoom = async () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "habitaciones/listar", {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log("habitaciones", data);
          resolve(data)
          this.setState({ habitaciones: data })

        })
        .catch((error) => {
          console.error('Error:', error);
          reject(error);
        });
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.open !== prevProps.open) {
      this.setState({ open: this.props.open });
    }

  }

  componentDidMount = () => {
    this.loadRoom()
  }

  render() {
    const { classes } = this.props;
    return (
      <ThemeProvider theme={theme}>
        <Dialog maxWidth="md" open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title" style={{ margin: 2 }} >Escoja una habitación</DialogTitle>
          <DialogContent>
            <FormControl className={classes.formControl}>
              <RadioGroup aria-label="habitacion" name="habitacion" value={this.state.habitacion} onChange={this.handleChange}>
                {this.state.habitaciones.length === 0 ? (
                  <p style={{ fontSize: '16px' }}>No hay habitaciones disponibles</p>
                ) : (
                  this.state.habitaciones.map((habitacion) => (
                    habitacion.estado === 'A' && (
                    <FormControlLabel key={habitacion.id_habitacion} value={`${habitacion.id_habitacion}`} control={<Radio />} label={`${habitacion.numero} - ${habitacion.descripcion}`} />)                  
                  ))
                )}
              </RadioGroup>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ marginRight: 5, marginLeft: 8, color: '#ffffff', textTransform: 'none' }}
              variant="contained"
              color="primary"
              onClick={this.handleClose}
            >
              Cerrar
            </Button>
            <Button
              style={{ marginRight: 21, marginLeft: 8, color: '#ffffff', textTransform: 'none' }}
              variant="contained"
              color="primary"
              onClick={() => {
                this.handleHabitacion();
                this.handleClose();
              }}
            >
              Guardar
            </Button>

          </DialogActions>
        </Dialog>
      </ThemeProvider>
    );
  }
}

export default withStyles(styles)(ModalSelectRoom);

